import * as React from 'react';

const SvgZap = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="#56565b"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="zap_svg__feather zap_svg__feather-zap"
    {...props}
  >
    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
  </svg>
);

export default SvgZap;
